export enum StoreMethodEnum {
  Post = 'POST',
  Get = 'GET'
}
